"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var Tooltip_1 = require("../../parts/Tooltip");
var utils_1 = require("../../../utils");
function default_1(gauge, chartTooltip, initialRun) {
    var _a = gauge.props, showDataLabels = _a.showDataLabels, showTooltips = _a.showTooltips, children = _a.children, onHide = _a.onHide, onShow = _a.onShow, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave, onClick = _a.onClick, type = _a.type, dial = _a.dial, manualColor = _a.manualColor, overrides = __rest(_a, ["showDataLabels", "showTooltips", "children", "onHide", "onShow", "onMouseEnter", "onMouseLeave", "onClick", "type", "dial", "manualColor"]);
    var seriesTooltip = utils_1.typeChildren(children).tooltip;
    var tooltip = seriesTooltip || chartTooltip;
    var options = __assign({ type: 'gauge', dial: __assign({ backgroundColor: '#000', baseLength: '110%', baseWidth: 25, borderWidth: 0, radius: '105%', rearLength: '-110%', topWidth: 0 }, dial), pivot: {
            radius: 0
        } }, overrides);
    options.className = manualColor ? 'manual-color' : '';
    options.tooltip = Tooltip_1.tooltipOptions({ showTooltips: showTooltips }, tooltip);
    options.dataLabels = { enabled: showDataLabels };
    if (initialRun) {
        options.events = utils_1.bindEventHandlers({ onClick: onClick, onMouseLeave: onMouseLeave, onMouseEnter: onMouseEnter, onShow: onShow, onHide: onHide });
    }
    return options;
}
exports.default = default_1;
//# sourceMappingURL=dialGaugeOptions.js.map